import PoolDetailView from 'components/views/PoolView/PoolDetailView';
import { mapSelectedPoolURLToID, POOL_TYPE } from 'defs/pools';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators as dashboardAC } from 'store/dashboard';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as favoritesAC } from 'store/favorites';
import { actionCreators as layoutAC } from 'store/layout';
import { getIsAuthenticated } from 'store/login';
import { getHasUserBeenLoaded, getUserData, getWeight } from 'store/profile';
import { itemTypes } from 'store/programItems';
import { IRootState } from 'store/rootReducer';
import {
	actionCreators as transientPoolAC,
	getActiveOverlayRef,
	getProgramItemRef,
	getSelectedItemById,
} from 'store/transientPoolState';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';
import { HistoryType, MatchType } from 'types/withRouter';

export type PoolDetailViewContainerProps = {
	history: HistoryType;
	match: MatchType & {
		params: {
			type: string;
			id: string;
		};
	};
};

export const mapStateToProps = (state: IRootState, props: PoolDetailViewContainerProps) => {
	const selectedPoolURL = props.match.params.selectedPool.toString() || '';
	const selectedItemID = props.match
		? props.match.params.programItemId
			? `${props.match.params.programItemId}`
			: ''
		: '';
	const selectedPoolID: PoolEnumType = mapSelectedPoolURLToID[selectedPoolURL] || undefined;
	let cardType;

	if (selectedPoolID === POOL_TYPE.WORKOUT) {
		cardType = itemTypes.WORKOUT;
	} else if (selectedPoolID === POOL_TYPE.RECIPE) {
		cardType = itemTypes.RECIPE;
	}

	return {
		isAuthenticated: getIsAuthenticated(state),
		isUserLoaded: getHasUserBeenLoaded(state),
		userData: getUserData(state),
		programItemRef: getProgramItemRef(state),
		activeOverlayRef: getActiveOverlayRef(state),
		content: getSelectedItemById(state, selectedItemID),
		weight: getWeight(state),
		selectedPoolID,
		selectedPoolURL,
		selectedItemID,
		contentType: cardType,
	};
};

export const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doLoadSelectedFavoriteData: favoritesAC.doLoadSelectedFavoriteData,
			doLockBody: layoutAC.doLockBody,
			doUnsetProgramItemRef: transientPoolAC.doUnsetProgramItemRef,
			doLoadSelectedItem: transientPoolAC.doLoadSelectedItem,
			doRequestMeasurement: dashboardAC.doRequestMeasurement,
			doAddEvents: eventsAC.doAddEvents,
		},
		dispatch
	);
};

export default withRouter((connect(mapStateToProps, mapDispatchToProps) as any)(PoolDetailView));
